/* eslint-disable no-use-before-define */
import React, { Fragment, useState, useEffect } from "react";

import { Cloudinary } from "../../../../apis/api";
import { helperFunction } from "../../../../constant/helper";
import { safetyQuestionsSample } from "./sample";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import Card from "../../../../component/card/Card";
import HeaderTag from "../../../../component/smallComponents/HeaderTag";
import Observation from "./Observation";
import P from "../../../../component/smallComponents/P";
import ProjectDetails from "./ProjectDetails";
import SafetyQuestions from "./SafetyQuestions";
import SpinnerButton from "../../../../component/spinner/SpinnerButton";
import Starter from "../../../../component/Starter";
import Strong from "../../../../component/smallComponents/Strong";
import UploadPhotos from "./UploadPhotos";
import WorkLog from "./WorkLog";
import {
  addAndEditDpr,
  clearDprErrors,
  clearDprResult,
  setDprLoading
} from "../../../../redux/actions/dprActions";

const initialState = {
  locationId: "",
  generalNotes: "",
  safetyObservation: "",
  qualityControlObservation: ""
};

const createDailyProgressReport = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;

  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [dprScreenshots, setDprScreenshots] = useState([]);
  const [dprScreenshotsLoading, setDprScreenshotsLoading] = useState(
    false
  );
  const [workLogField, setWorkLogField] = useState([
    {
      addDescription: "",
      addManpower: "",
      addOnSiteAssignment: ""
    }
  ]);
  const [safetyQuestions, setSafetyQuestions] = useState(
    safetyQuestionsSample
  );
  const { dprLoading, dprError, dprResponse } = useSelector(
    (state) => state.dpr
  );
  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);

  useEffect(() => {
    dispatch(setDprLoading(false));
    dispatch(clearDprErrors());
    dispatch(clearDprErrors());
    return () => {
      dispatch(setDprLoading(false));
      dispatch(clearDprErrors());
      dispatch(clearDprErrors());
    };
  }, []);

  const handleInitialState = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (dprError) {
      helperFunction.toastHelper("error", dprError);
    }
    if (dprResponse) {
      helperFunction.toastHelper("success", dprResponse);
    }
  }, [dprError, dprResponse]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  const onWorkLogChange = (inComingIndex) => (e) => {
    const { name, value } = e.target;
    const newWorkLog = workLogField.map((workLog, foundIndex) => {
      if (inComingIndex !== foundIndex) return workLog;
      return { ...workLog, [name]: value.toUpperCase() };
    });
    setWorkLogField(newWorkLog);
  };
  const onSafetyQuestionsChanges = (inComingIndex) => (e) => {
    const { name, value } = e.target;
    const newSafetyQuestions = safetyQuestions.map(
      (safetyQuestion, foundIndex) => {
        if (inComingIndex !== foundIndex) return safetyQuestion;
        return { ...safetyQuestion, [name]: value };
      }
    );
    setSafetyQuestions(newSafetyQuestions);
  };

  // add workLog array
  const onAddWorkLog = () => {
    setWorkLogField([
      ...workLogField,
      {
        addDescription: "",
        addManpower: "",
        addOnSiteAssignment: ""
      }
    ]);
  };

  // remove workLog
  const onRemoveWorkLog = (inComingIndex) => () => {
    const removedWorkLogInput = workLogField.filter(
      (workLog, foundIndex) => {
        return inComingIndex !== foundIndex;
      }
    );
    setWorkLogField(removedWorkLogInput);
  };
  // location change
  // const onLocationChange = (e) => {
  //   const { value } = e.target;
  //   setSelectLocationId(value);
  //   dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
  // };

  // upload image to cloudinary and get secure url
  const getImagesUrl = async (screenshots) => {
    setDprScreenshotsLoading(true);
    const imagesUrl = await helperFunction.uploadMultipleImageToCloudinary(
      screenshots,
      Cloudinary.CLOUD_NAME,
      Cloudinary.CLOUDINARY_API,
      Cloudinary.DPR_PRESET
    );
    setDprScreenshots(dprScreenshots.concat(imagesUrl));
    setDprScreenshotsLoading(false);
  };

  // on submit / create dpr
  const onSubmit = (e) => {
    e.preventDefault();
    const dprId = "addDpr";
    const dprData = {
      workLogField,
      dprScreenshots,
      safetyQuestions,
      locationId: values.locationId,
      generalNotes: values.generalNotes,
      safetyObservation: values.safetyObservation,
      qualityControlObservation: values.qualityControlObservation
    };
    dispatch(setDprLoading(true));
    dispatch(clearDprErrors());
    dispatch(clearDprResult());
    dispatch(addAndEditDpr(dprData, dprId, loginType));
  };
  return (
    <Starter
      topBarTitle="Create DPR "
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">DPR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Report</a>
          </li>
          <li className="breadcrumb-item active">Create DPR</li>
        </Fragment>
      }
    >
      <form onSubmit={onSubmit}>
        <Card>
          <div className="row mt-1 mb-1 h1">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 h1 text-center">
              Daily Progress Report
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <Strong className="text-danger float-right">
                All inputs with * are compulsory*
              </Strong>
              <HeaderTag
                type="h4"
                isClassName={false}
                title="Add Project Details"
              />
              <P title="Fill the form below to Add Project Details" />
            </div>
          </div>
          <ProjectDetails
            values={values}
            currentUser={currentUser}
            handleInitialState={handleInitialState}
            allLocations={
              typeof allLocations !== "undefined" &&
              allLocations.length > 0
                ? allLocations
                : []
            }
          />
        </Card>
        <Card>
          <div className="row mt-1 mb-1 ">
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 h4">
              Work Logs
            </div>
            <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 ">
              <Button
                title="Add"
                type="button"
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                onClick={(e, index) => onAddWorkLog(index)}
                className="btn text-white btn-block btn-primary"
              />
            </div>
          </div>
          <div className="row mt-1 mb-1 ">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
              {workLogField.map((workLogValues, index) => (
                <div key={index}>
                  <WorkLog
                    workLogIndex={index}
                    workLogValues={workLogValues}
                    onRemoveWorkLog={onRemoveWorkLog}
                    onWorkLogChange={onWorkLogChange}
                    handleInitialState={handleInitialState}
                  />
                </div>
              ))}
            </div>
          </div>
        </Card>
        <Card>
          <div className="row mt-1 mb-1 ">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 h4">
              Safety Questions
            </div>
          </div>
          <div className="row mt-1 mb-1 ">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
              {safetyQuestions.map((safetyQuestionValues, index) => (
                <div key={index}>
                  <SafetyQuestions
                    inComingIndexSQ={index}
                    safetyQuestionValues={safetyQuestionValues}
                    onSafetyQuestionsChanges={
                      onSafetyQuestionsChanges
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </Card>
        <Card>
          <Observation
            handleInitialState={handleInitialState}
            values={values}
          />
        </Card>
        <Card>
          <UploadPhotos
            getImagesUrl={getImagesUrl}
            dprScreenshots={dprScreenshots}
          />
          <div className="row mt-3">
            <div className="col-md-4 col-xl-4 col-lg-4">
              {dprLoading ? (
                <SpinnerButton />
              ) : dprScreenshotsLoading ? (
                <Button
                  type="submit"
                  title="Submit"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                  className="btn text-white btn-block btn-dark"
                  disabled
                />
              ) : (
                <Button
                  type="submit"
                  title="Submit"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                  className="btn text-white btn-block btn-dark"
                />
              )}
            </div>
          </div>
        </Card>
      </form>
    </Starter>
  );
};

export default createDailyProgressReport;
